import { GET_CURRENT_COMPANY } from "constants/companies";

export default (state = {}, action) => {
  switch (action.type) {
    case `${GET_CURRENT_COMPANY}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
